import React, { useState, useEffect } from 'react';
import axios from 'axios';
import './Authentications.css';

const Authentication = () => {
  const [authList, setAuthList] = useState([]);
  const [adding, setAdding] = useState(false);
  const [selectedTool, setSelectedTool] = useState('');
  const [selectedModel, setSelectedModel] = useState('');
  const [authInput, setAuthInput] = useState([]);
  const [availableTools, setAvailableTools] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    console.log('user-->',user)
    const userId = user.user.id;
    console.log('userId-->',userId)

    // Load tools
    axios.get('/api/tools')
      .then(res => setAvailableTools(res.data))
      .catch(err => console.error('Failed to load tools:', err));

    // Load key_auth entries
    axios.get(`/api/key_auth?user_id=${userId}`)
    // axios.get(`/api/key_auth`)
  .then(res => {
    const groupedObj = {};

    res.data.forEach(item => {
      const key = `${item.tool}_${item.authentication_id}`;
      if (!groupedObj[key]) {
        groupedObj[key] = {
          tool: item.tool,
          authentication_id: item.authentication_id,
          params: []
        };
      }
      groupedObj[key].params.push({ key: item.key, value: item.value });
    });

    const grouped = Object.values(groupedObj);
    setAuthList(grouped);
  })
  .catch(err => console.error('Failed to fetch auths:', err));
  }, []);

  const handleStartAdd = () => {
    setAdding(true);
    setSelectedTool('');
    setAuthInput([]);
    setSelectedModel('');
  };

  const handleToolSelect = (toolName) => {
    setSelectedTool(toolName);
    const tool = availableTools.find(t => t.name === toolName);
    if (tool?.keys) {
      setAuthInput(tool.keys.map(k => ({
        key: k.key,
        value: '',
        placeholder: k.placeholder || '',
        ...(k.select && { select: k.select })
      })));
    } else {
      setAuthInput([]);
    }
    if (tool?.submodels?.length) {
      setSelectedModel(tool.submodels[0]);
    } else {
      setSelectedModel('');
    }
  };

  const handleParamChange = (index, field, value) => {
    const updated = [...authInput];
    updated[index][field] = value;
    setAuthInput(updated);
  };

  const handleAdd = async () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    console.log('user-->',user)
    const userId = user.user.id;
    console.log('userId-->',userId)
    const authId = `${userId}_${selectedTool}`; 
    console.log('authId-->',authId)
    console.log('--selectedTool--'+selectedTool+'--selectedModel--'+selectedModel+'--authId--'+authId+'--authInput--'+authInput)

    try {
      const response = await axios.post('/api/auth', {
        userId,
        tool: selectedTool,
        model: selectedModel,
        params: authInput
      });
      const newAuth = {
        tool: selectedTool,
        model: selectedModel,
        params: authInput,
        authentication_id: response.data.authentication_id  // optional if returned
      };
      console.log('2--->:');

      const updatedList = [...authList, newAuth];
      console.log('3--->:');

      setAuthList(updatedList);
      console.log('4--->:');

      user.authentications = updatedList;
      console.log('user--->:',user);

      localStorage.setItem('user', JSON.stringify(user));
      console.log('6--->:');

      setAdding(false);
    } catch (err) {
      console.error('Error saving authentication:', err);
      alert('Failed to save authentication');
    }
  };

  const handleDelete = async (authId) => {
    try {
      await axios.delete(`/api/key_auth/${authId}`);
      setAuthList(authList.filter(a => a.authentication_id !== authId));
    } catch (err) {
      console.error('Error deleting authentication:', err);
      alert('Failed to delete authentication');
    }
  };

  return (
    <div className="auth-container">
      <div className="auth-header">
        <h2>{adding ? 'Add Authentication' : 'Authentications'}</h2>
        {adding ? (
          selectedTool && <button className="button" onClick={() => setAuthInput([...authInput, { key: '', value: '', placeholder: 'Enter custom key/value' }])}>+ Add New Pair</button>
        ) : (
          <button className="button" onClick={handleStartAdd}>+ Add Authentication</button>
        )}
      </div>

      {!adding ? (
        <div className="auth-list">
          {authList.map((auth, idx) => (
            <div className="auth-card-view" key={idx}>
              <h4 className="auth-card-title">{auth.tool}</h4>
              <div className="auth-card-body">
                {editingIndex === idx ? (
                  <>
                    {auth.params.map((p, i) => (
                      <div key={i} className="auth-row">
                        <input className="input" value={p.key} readOnly />
                        <input
                          className="input"
                          value={p.value}
                          onChange={(e) => {
                            const updated = [...authList];
                            updated[idx].params[i].value = e.target.value;
                            setAuthList(updated);
                          }}
                        />
                      </div>
                    ))}
                    <div className="auth-actions">
                      <button className="button edit" onClick={() => setEditingIndex(null)}>Save</button>
                      <button className="button delete" onClick={() => setEditingIndex(null)}>Cancel</button>
                    </div>
                  </>
                ) : (
                  <>
                    {auth.params.map((p, i) => (
                      <div key={i} className="auth-param">
                        <strong>{p.key}:</strong> <span>{p.value}</span>
                      </div>
                    ))}
                    <div className="auth-actions">
                      <button className="button edit" onClick={() => setEditingIndex(idx)}>✏️ Edit</button>
                      <button className="button delete" onClick={() => handleDelete(auth.authentication_id)}>🗑️ Delete</button>
                    </div>
                  </>
                )}
              </div>
            </div>
          ))}
        </div>
      ) : (
        <div className="auth-form">
          <select
            className="input select-fix"
            value={selectedTool}
            onChange={(e) => handleToolSelect(e.target.value)}
          >
            <option value="">Select Tool</option>
            {availableTools.map((tool, i) => (
              <option key={i} value={tool.name}>{tool.name}</option>
            ))}
          </select>

          {selectedTool && selectedModel && (
            <select
              className="input select-fix"
              value={selectedModel}
              onChange={(e) => setSelectedModel(e.target.value)}
            >
              {availableTools.find(t => t.name === selectedTool)?.submodels?.map((model, i) => (
                <option key={i} value={model}>{model}</option>
              ))}
            </select>
          )}

          {authInput.map((item, index) => (
            <div key={index} className="auth-row">
              <input
                className="input"
                type="text"
                placeholder={item.key || 'Key'}
                value={item.key}
                readOnly
              />

              {item.placeholder === 'DropDown' ? (
                <select
                  className="input"
                  value={item.value || ''}
                  onChange={(e) => handleParamChange(index, 'value', e.target.value)}
                >
                  <option value="">Select an option</option>
                  {(item.select || []).map((option, i) => (
                    <option key={i} value={option}>{option}</option>
                  ))}
                </select>
              ) : (
                <input
                  className="input"
                  type="text"
                  placeholder={item.placeholder || 'Value'}
                  value={item.value || ''}
                  onChange={(e) => handleParamChange(index, 'value', e.target.value)}
                />
              )}
            </div>
          ))}

          <div className="auth-actions">
            <button className="button" onClick={handleAdd}>Add</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Authentication;